import {StorageDAO} from '../DAO/StorageDAO';
import {BaseService} from './BaseService';

/**
 * StorageDAO
 *
 * ブラウザ領域のストレージを利用するDAO
 * ionicのstorageクラスを使って操作する
 *
 * ※sqlite使う場合は下記インストール必須(Cordovaビルドのみ)
 * ionic cordova plugin add cordova-sqlite-storage
 *
 */
export class StorageService extends BaseService {

	/**
	 * isItemExist
	 *
	 * 存在チェック
	 * ストレージから取得して中身が存在するかをチェックしてbooleanを返す
	 * @param key チェックするキー string
	 */
	public async isItemExist(key: string) {


		const dao = new StorageDAO(this);
		const ret = await dao.isItemExist(key);

		return ret;

	}

	/**
	 * saveItem
	 *
	 * ストレージにItemを保存する
	 * 使用するストレージの優先順位はconstructorで設定したdefaultConfigによる
	 * @param key 値の保存に設定するキー
	 * @param val 値
	 */

	public async saveItem(key: string, val: string) {

		const dao = new StorageDAO(this);
		return await dao.saveItem(key, val);

	}


	/**
	 * getItem
	 *
	 * ストレージからItemを取得する
	 * 使用するストレージの優先順位はconstructorで設定したdefaultConfigによる
	 * @param key 値を取得するキー
	 */
	public async getItem(key: string) {

		const dao = new StorageDAO(this);

		// ストレージから値が取得する
		const val = await dao.getItem(key);
		// 値がなかった場合はfalseを返す
		if (!val) {
			this.log('no item with key: ' + key);
			return false;
		}
		return val;
	}


	public async delete(key: string) {
		const dao = new StorageDAO(this);
		return await dao.deleteItem(key);
	}

	/**
	 * clear
	 *
	 * ストレージから保存データをすべて破棄する
	 */
	public async clear() {

		const dao = new StorageDAO(this);
		return await dao.clear();

	}
}
